import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { mapToString } from 'fmrs';
import {} from 'react';
export default function DefaultErrorBoundaryFallback({ error, }) {
    return _jsx(_Fragment, { children: mapToString(error) });
}
//# sourceMappingURL=default-error-boundary-fallback.view.js.map